import { ChakraProvider } from '@chakra-ui/react'
import { theme } from '@olagg/ui-kit'
import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

let customFonts = theme;
customFonts.fonts.body = 'rajdhani,sans-serif'

const rootElement = document.getElementById('root')!
ReactDOM.createRoot(rootElement).render(
  // <React.StrictMode>
    <ChakraProvider theme={theme}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ChakraProvider>
  // </React.StrictMode>
)
